import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowDownCircleXs = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M8 1.25C11.7279 1.25 14.75 4.27208 14.75 8C14.75 11.7279 11.7279 14.75 8 14.75C4.27208 14.75 1.25 11.7279 1.25 8C1.25 4.27208 4.27208 1.25 8 1.25ZM8 2.75C5.10051 2.75 2.75 5.10051 2.75 8C2.75 10.8995 5.10051 13.25 8 13.25C10.8995 13.25 13.25 10.8995 13.25 8C13.25 5.10051 10.8995 2.75 8 2.75ZM8 4C8.41421 4 8.75 4.33579 8.75 4.75V9.43945L10.7197 7.46973C11.0126 7.17683 11.4874 7.17683 11.7803 7.46973C12.0732 7.76262 12.0732 8.23738 11.7803 8.53027L8.53027 11.7803C8.38583 11.9123 8.19804 12 8 12C7.80196 12 7.60855 11.9191 7.46973 11.7803L4.16797 8.47363C3.92766 8.17905 3.94512 7.74433 4.21973 7.46973C4.49433 7.19512 4.92905 7.17766 5.22363 7.41797L7.25 9.43945V4.75C7.25 4.33579 7.58579 4 8 4Z",
            fill: color
        })
    });

//# sourceMappingURL=arrow-down-circle-xs.js.map